import { Component, Input } from '@angular/core';
import { BankDetailRowComponent } from '../bank-detail-row.component';

@Component({
  selector: 'app-bank-detail-row-touch',
  templateUrl: './bank-detail-row-touch.component.html',
  styleUrls: [
    '../bank-detail-row.component.scss',
    './bank-detail-row-touch.component.scss',
  ],
})
export class BankDetailRowTouchComponent extends BankDetailRowComponent {
  @Input() isMobile: boolean;
}
